import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/use-auth'
import { iamApi } from '@/api/client'

export function SiteCreatePage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { activeTenantId } = useAuth()
  const [form, setForm] = useState({ name: '', slug: '', domain: '', description: '' })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!activeTenantId) return
    setLoading(true)
    setError('')
    try {
      const { data } = await iamApi.post(`/tenants/${activeTenantId}/sites`, form)
      navigate(`/sites/${data.id}`)
    } catch {
      setError(t('common.error'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold text-foreground mb-6">{t('sites.create')}</h1>
      <form onSubmit={handleSubmit} className="bg-card border border-border rounded-xl p-6 flex flex-col gap-4">
        <div>
          <label className="text-sm font-medium text-foreground mb-1 block">{t('sites.name')}</label>
          <input
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full rounded-lg border border-input px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
            required
          />
        </div>
        <div>
          <label className="text-sm font-medium text-foreground mb-1 block">{t('sites.slug')}</label>
          <input
            value={form.slug}
            onChange={(e) => setForm({ ...form, slug: e.target.value })}
            className="w-full rounded-lg border border-input px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
            required
          />
        </div>
        <div>
          <label className="text-sm font-medium text-foreground mb-1 block">{t('sites.domain')}</label>
          <input
            value={form.domain}
            onChange={(e) => setForm({ ...form, domain: e.target.value })}
            className="w-full rounded-lg border border-input px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>
        <div>
          <label className="text-sm font-medium text-foreground mb-1 block">{t('sites.description')}</label>
          <textarea
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
            className="w-full rounded-lg border border-input px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring min-h-[80px]"
          />
        </div>
        {error && <p className="text-sm text-destructive">{error}</p>}
        <div className="flex gap-3 justify-end">
          <button type="button" onClick={() => navigate('/sites')} className="px-4 py-2 text-sm rounded-lg border border-input hover:bg-secondary transition-colors">
            {t('common.cancel')}
          </button>
          <button type="submit" disabled={loading} className="px-4 py-2 text-sm rounded-lg bg-accent text-accent-foreground hover:bg-accent-600 transition-colors disabled:opacity-50">
            {loading ? t('common.loading') : t('common.save')}
          </button>
        </div>
      </form>
    </div>
  )
}
